<div [class.card-tabs]="cardTabs"
     [class.work-ui-tabs--no-padding]="noPadding"
     class="work-ui-tabs">
  <div class="flex flex-row bottom space-between gap-16 border-bottom">
    <div class="work-ui-tabs__container">
      <ul #tabGroup [class.hide]="tabsDoOverflow()" [attr.aria-label]="'REGISTERKARTEN' | translate" role="tablist">
        @for (tab of tabOptions; track tab; let i = $index) {
          @if (!tab.hidden) {
            <li role="presentation">
              <button #tabButton
                      (click)="activateTab(tab.tabReference)"
                      (keydown)="onKeydown($event)"
                      [attr.aria-controls]="'tabpanel-' + tab.tabReference"
                      [attr.aria-selected]="tab.tabReference === activeTab"
                      [attr.tabindex]="tab.tabReference === activeTab ? 0 : -1"
                      [id]="'tab-' + tab.tabReference"
                      role="tab">
                @if (tab.iconName) {
                  <work-ui-icon [fontSize]="18" [name]="tab.iconName" />
                }
                {{ tab.title | translate }}
                @if (tab.badgeValue) {
                  <span class="work-badge">{{ tab.badgeValue }}</span>
                }
                @if (tab.iconErrorName) {
                  <work-ui-icon [fontSize]="18" [name]="tab.iconErrorName" fontColor="error" />
                }</button>
            </li>
          }
        }
      </ul>
      @if (tabsDoOverflow()) {
        <div class="work-ui-tabs__select-container"
             [class.work-ui-tabs__select-container--no-padding]="noPadding">
          <work-ui-select (valueChanged)="activateTab($event)"
                          [hideHint]="true"
                          [name]="'tabOptionsMobile'"
                          [options]="selectOptions"
                          [value]="activeTab">
          </work-ui-select>
        </div>
      }
    </div>

    <div class="work-ui-tabs__actions">
      <ng-content select="[tabs-actions]"></ng-content>
    </div>
  </div>
  @if (tabContentTemplates) {
    @for (contentDirective of tabContentTemplates.toArray(); track contentDirective) {
      <div [attr.aria-labelledby]="'tab-' + contentDirective.tabReference"
           [class.active]="contentDirective.tabReference === activeTab"
           [class.content-padding-bottom]="contentPadding && noPadding"
           [class.work-office-layout__page-body]="!noPadding"
           [id]="'tabpanel-' + contentDirective.tabReference"
           class="work-ui-tabs__panel"
           role="tabpanel">
        <ng-template [ngTemplateOutlet]="contentDirective.template"></ng-template>
      </div>
    }
  }
</div>
